// READ ME PLEASE:
//     THIS FILE IS A GENERATED. AND SHOULD BE GITIGNORED
//     YOU PROBABLY DO NOT WANT TO ALTER IT. IT'll WASTE YOUR TIME.
//     If it needs changes please set up a model that inherits and overrides
//     the behavior.

import {BaseModel} from '../Core/BaseModel';

import * as validators from '../Core/Validators';

import {
	PasswordsMatchValidator,
	RequiredValidator,
	PrimaryKeyRequiredValidator,
	PasswordRequiredValidator,
	MaxLengthValidator,
	NumericValidator,
	UnsignedNumberValidator,
} from '../Core/Validators';
import {Species} from './Species';
import {SpeciesType} from './SpeciesType';
import {SpeciesNativity} from './SpeciesNativity';
import {SpeciesInvasivity} from './SpeciesInvasivity';

const _associations = [
			{
				name: 'Species',
				model: new Species(),
				type: 'ArrayOfChildren',
				using: 'speciesId',
				isHidden: true,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				isOne: false,
				editor: 'ChildrenFieldEditor',
				viewer: 'ChildrenFieldViewer',
				isNullable: false,
				displayLabel: true,
				isMutable: true,
				requiresPermission: null,
				group: '',
				groupTitle: null,
				itemTitle: 'Global Species',
				orderable: false,
				sortKey: null,
				nonMutable: false,
				listComponentOverride: false,
				customData: {
				}
			},
			{
				name: 'SpeciesType',
				model: new SpeciesType(),
				type: 'ParentPointer',
				using: 'speciesTypeId',
				isHidden: true,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				isOne: true,
				editor: 'ChildrenFieldEditor',
				viewer: 'ChildrenFieldViewer',
				isNullable: false,
				displayLabel: true,
				isMutable: true,
				requiresPermission: null,
				group: '',
				groupTitle: null,
				itemTitle: 'SpeciesType',
				orderable: false,
				sortKey: null,
				nonMutable: false,
				listComponentOverride: false,
				customData: {
				}
			},
			{
				name: 'SpeciesNativity',
				model: new SpeciesNativity(),
				type: 'ParentPointer',
				using: 'speciesNativityId',
				isHidden: true,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				isOne: true,
				editor: 'ChildrenFieldEditor',
				viewer: 'ChildrenFieldViewer',
				isNullable: false,
				displayLabel: true,
				isMutable: true,
				requiresPermission: null,
				group: '',
				groupTitle: null,
				itemTitle: 'SpeciesNativity',
				orderable: false,
				sortKey: null,
				nonMutable: false,
				listComponentOverride: false,
				customData: {
				}
			},
			{
				name: 'SpeciesInvasivity',
				model: new SpeciesInvasivity(),
				type: 'ParentPointer',
				using: 'speciesInvasivityId',
				isHidden: true,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				isOne: true,
				editor: 'ChildrenFieldEditor',
				viewer: 'ChildrenFieldViewer',
				isNullable: false,
				displayLabel: true,
				isMutable: true,
				requiresPermission: null,
				group: '',
				groupTitle: null,
				itemTitle: 'SpeciesInvasivity',
				orderable: false,
				sortKey: null,
				nonMutable: false,
				listComponentOverride: false,
				customData: {
				}
			},
];

const _fieldDefs = [
			{
				title: 'speciesListSpeciesId',
				placeholder: null,
				key: 'speciesListSpeciesId',
				isPrimaryKey: true,
				allowNull: false,
				displayLabel: true,
				isHidden: true,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.speciesListSpeciesId,
				setter: (x, y) => x.speciesListSpeciesId = y,
				defaultValue: null,
				editor: 'NumberFieldEditor',
				viewer: 'NumberFieldViewer',
				validators: [
					new PrimaryKeyRequiredValidator(),
					new NumericValidator(),
				],
				formatter: {
					name: "NumberFormatter",
					params: [
					]
				},
				customData: {
				}
			},
			{
				title: 'speciesListId',
				placeholder: null,
				key: 'speciesListId',
				isPrimaryKey: false,
				allowNull: false,
				displayLabel: true,
				isHidden: true,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.speciesListId,
				setter: (x, y) => x.speciesListId = y,
				defaultValue: null,
				editor: 'NumberFieldEditor',
				viewer: 'NumberFieldViewer',
				validators: [
					new RequiredValidator(),
					new NumericValidator(),
				],
				formatter: {
					name: "NumberFormatter",
					params: [
					]
				},
				customData: {
				}
			},
			{
				title: 'Species',
				placeholder: null,
				key: 'speciesId',
				isPrimaryKey: false,
				allowNull: false,
				displayLabel: true,
				isHidden: true,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				displayOrder: 1,
				getter: (x) => x.speciesId,
				setter: (x, y) => x.speciesId = y,
				defaultValue: 1,
				editor: 'NumberFieldEditor',
				viewer: 'NumberFieldViewer',
				validators: [
					new NumericValidator(),
				],
				formatter: {
					name: "NumberFormatter",
					params: [
					]
				},
				customData: {
				}
			},
			{
				title: 'Common Name',
				placeholder: null,
				key: 'alternativeCommonName',
				isPrimaryKey: false,
				allowNull: true,
				displayLabel: true,
				isHidden: false,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				displayOrder: 3,
				getter: (x) => x.alternativeCommonName,
				setter: (x, y) => x.alternativeCommonName = y,
				defaultValue: null,
				editor: 'TextFieldEditor',
				viewer: 'TextFieldViewer',
				renderer: 'SpeciesListSpeciesModelViewerRecordRenderer',
				validators: [
					new MaxLengthValidator(45),
				],
				formatter: {
				},
				customData: {
				}
			},
			{
				title: 'Scientific Name',
				placeholder: null,
				key: 'alternativeLatinName',
				isPrimaryKey: false,
				allowNull: true,
				displayLabel: true,
				isHidden: false,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				displayOrder: 2,
				getter: (x) => x.alternativeLatinName,
				setter: (x, y) => x.alternativeLatinName = y,
				defaultValue: null,
				editor: 'TextFieldViewer',
				viewer: 'TextFieldViewer',
				renderer: 'SpeciesListSpeciesModelViewerRecordRenderer',
				validators: [
					new MaxLengthValidator(45),
				],
				formatter: {
				},
				customData: {
				}
			},
			{
				title: 'Growth Form',
				placeholder: null,
				key: 'speciesTypeId',
				isPrimaryKey: false,
				allowNull: false,
				displayLabel: true,
				isHidden: false,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				displayOrder: 4,
				getter: (x) => x.speciesTypeId,
				setter: (x, y) => x.speciesTypeId = y,
				defaultValue: null,
				editor: 'SpeciesTypeFieldEditor',
				viewer: 'SpeciesTypeFieldViewer',
				renderer: 'SpeciesListSpeciesModelViewerRecordRenderer',
				validators: [
					new RequiredValidator(),
					new NumericValidator(),
				],
				formatter: {
					name: "NumberFormatter",
					params: [
					]
				},
				customData: {
				}
			},
			{
				title: 'Nativity',
				placeholder: null,
				key: 'speciesNativityId',
				isPrimaryKey: false,
				allowNull: false,
				displayLabel: true,
				isHidden: false,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				displayOrder: 5,
				getter: (x) => x.speciesNativityId,
				setter: (x, y) => x.speciesNativityId = y,
				defaultValue: null,
				editor: 'SpeciesNativityFieldEditor',
				viewer: 'SpeciesNativityFieldViewer',
				renderer: 'SpeciesListSpeciesModelViewerRecordRenderer',
				validators: [
					new RequiredValidator(),
					new NumericValidator(),
					new validators.NoxiousIsIntroducedValidator(),
				],
				formatter: {
					name: "NumberFormatter",
					params: [
					]
				},
				customData: {
				}
			},
			{
				title: 'Invasivity',
				placeholder: null,
				key: 'speciesInvasivityId',
				isPrimaryKey: false,
				allowNull: false,
				displayLabel: true,
				isHidden: false,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				displayOrder: 6,
				getter: (x) => x.speciesInvasivityId,
				setter: (x, y) => x.speciesInvasivityId = y,
				defaultValue: null,
				editor: 'SpeciesInvasivityFieldEditor',
				viewer: 'SpeciesInvasivityFieldViewer',
				renderer: 'SpeciesListSpeciesModelViewerRecordRenderer',
				validators: [
					new RequiredValidator(),
					new NumericValidator(),
				],
				formatter: {
					name: "NumberFormatter",
					params: [
					]
				},
				customData: {
				}
			},
			{
				title: 'Visibility',
				placeholder: null,
				key: 'searchable',
				isPrimaryKey: false,
				allowNull: false,
				displayLabel: true,
				isHidden: false,
				editorOnly: false,
				viewerOnly: false,
				helpText: 'When checked this species will show up in search boxes and dropdowns. When unchecked this species will \
                           be hidden from search boxes or dropdowns, however instances of it may still appear in reports. The overriden name and \
                           categories will be used in reports. If you wish to completely hide this species from reports remove it from your \
                           custom species list.',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				displayOrder: 7,
				getter: (x) => x.searchable,
				setter: (x, y) => x.searchable = y,
				defaultValue: null,
				editor: 'BooleanEditor',
				viewer: 'BooleanViewer',
				validators: [
					new RequiredValidator(),
					new NumericValidator(),
				],
				formatter: {
					name: "NumberFormatter",
					params: [
					]
				},
				customData: {
				}
			},
			{
				title: 'Created',
				placeholder: null,
				key: 'created',
				isPrimaryKey: false,
				allowNull: false,
				displayLabel: true,
				isHidden: {
					query: 'speciesListSpeciesId == null',
				},
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: 'NO_ONE_HAS_THIS_PERMISSION',
				group: '',
				groupTitle: null,
				displayOrder: 10,
				getter: (x) => x.created,
				setter: (x, y) => x.created = y,
				defaultValue: null,
				editor: 'DateFieldEditor',
				viewer: 'DateTimeFieldViewer',
				validators: [
				],
				formatter: {
				},
				customData: {
				}
			},
			{
				title: 'Last Modified',
				placeholder: null,
				key: 'modified',
				isPrimaryKey: false,
				allowNull: true,
				displayLabel: true,
				isHidden: {
					query: 'speciesListSpeciesId == null',
				},
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: 'NO_ONE_HAS_THIS_PERMISSION',
				group: '',
				groupTitle: null,
				displayOrder: 12,
				getter: (x) => x.modified,
				setter: (x, y) => x.modified = y,
				defaultValue: null,
				editor: 'DateFieldEditor',
				viewer: 'DateTimeFieldViewer',
				validators: [
				],
				formatter: {
				},
				customData: {
				}
			},
			{
				title: 'deleted',
				placeholder: null,
				key: 'deleted',
				isPrimaryKey: false,
				allowNull: true,
				displayLabel: true,
				isHidden: true,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.deleted,
				setter: (x, y) => x.deleted = y,
				defaultValue: null,
				editor: 'DateFieldEditor',
				viewer: 'DateFieldViewer',
				validators: [
				],
				formatter: {
				},
				customData: {
				}
			},
			{
				title: 'deletedKey',
				placeholder: null,
				key: 'deletedKey',
				isPrimaryKey: false,
				allowNull: true,
				displayLabel: true,
				isHidden: true,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.deletedKey,
				setter: (x, y) => x.deletedKey = y,
				defaultValue: null,
				editor: 'TextFieldEditor',
				viewer: 'TextFieldViewer',
				validators: [
				],
				formatter: {
				},
				customData: {
				}
			},
];

export class SpeciesListSpecies extends BaseModel {
	constructor() {
		super();
	}

	get groupRenderers() {
		return {
		};
	}

	get recordValidators() {
		return this._recordValidators ?? ( this._recordValidators = [		]);
	}

	get associations() {
		return _associations;
	}
	get fieldDefs() {
		return _fieldDefs;
	}

}
